import { hackathons } from "../data/portfolio";
import "../styles/Portfolio.css";

const HackathonsSection = () => {
  return (
    <section id="hackathons" className="portfolio-section">
      <div className="portfolio-container">
        <h2 className="section-label">Hackathons</h2>
        <div className="card-grid">
          {hackathons.map((hackathon, index) => (
            <div className="card hackathon-card" key={index}>
              <h3 className="card-title">{hackathon.name}</h3>
              <p className="hackathon-project">
                {hackathon.links && hackathon.links.length > 0 ? (
                  <a
                    href={hackathon.links[0].url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="hackathon-project-link"
                  >
                    {hackathon.project}
                  </a>
                ) : (
                  hackathon.project
                )}
              </p>
              <p className="card-subtitle">{hackathon.description}</p>
              {hackathon.prize && (
                <span className="hackathon-prize">{hackathon.prize}</span>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HackathonsSection;
